import { useTranslation } from 'react-i18next';
import { getHoursAndMinutesFromMinutes } from '@/utils/dateFunctions/getHoursAndMinutesFromMinutes';

export function DurationDisplay({ duration }: { duration: number }) {
  const { t } = useTranslation();

  const { hours, minutes }: { hours: number; minutes: number } =
    getHoursAndMinutesFromMinutes(duration);

  const absHours = Math.abs(hours);
  const absMinutes = Math.abs(minutes);

  if (Math.abs(duration) === 0) {
    return <span>--</span>;
  }

  return (
    <div className="flex gap-1 items-baseline font-semibold">
      {absHours > 0 && (
        <>
          {absHours}
          <span className="text-neutrals-700 text-xs">
            {t('general.date.hours')}
          </span>
        </>
      )}
      {absMinutes}
      <span className="text-neutrals-700 text-xs">
        {t('general.date.minutes')}
      </span>
    </div>
  );
}
